import { ROUTE_PAGE_SUBSCRIPTION } from '@components/Router/constants'
import { UpgradePlanActions } from '@store/reducers/upgradePlan'
import type { PlanType } from '@store/reducers/upgradePlan/types'
import type React from 'react'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Navigate, useSearchParams } from 'react-router-dom'

import { AuthenticatedWrapper } from './AuthenticatedWrapper'

const PLAN_TYPES: PlanType[] = ['monthly', 'annual']

const isPlanType = (value: string | null): value is PlanType =>
  PLAN_TYPES.includes(value as PlanType)

const StartCheckout: React.FC = () => {
  const dispatch = useDispatch()
  const [params] = useSearchParams()

  const planId = params.get('planId')
  const planType = params.get('planType')

  useEffect(() => {
    if (planId && isPlanType(planType)) {
      dispatch(UpgradePlanActions.updatePayment({ planId, planType }))
    }
  }, [])

  if (!planId || !isPlanType(planType)) {
    return <Navigate to={ROUTE_PAGE_SUBSCRIPTION} replace />
  }

  return null
}

export const SubscriptionCheckout: React.FC = () => (
  <AuthenticatedWrapper>
    <StartCheckout />
  </AuthenticatedWrapper>
)
